function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.752 2a6 6 0 110 12v2a8.001 8.001 0 007.939-7h5.062V7H17.69a8.001 8.001 0 00-7.939-7v2z",
  fill: "#5C6475"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.752 12a4.002 4.002 0 01-3.874-3H.752V7h5.126a4.002 4.002 0 017.874 1 4 4 0 01-4 4zm0-2a2 2 0 100-4 2 2 0 000 4z",
  fill: "#5C6475"
});

var SvgConnectionIcon = function SvgConnectionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNzUyNDcgMkMxMy4wNjYyIDIgMTUuNzUyNSA0LjY4NjI5IDE1Ljc1MjUgOEMxNS43NTI1IDExLjMxMzcgMTMuMDY2MiAxNCA5Ljc1MjQ3IDE0VjE2QzEzLjgzMjEgMTYgMTcuMTk4NSAxMi45NDYzIDE3LjY5MDYgOUgyMi43NTI1VjdIMTcuNjkwNkMxNy4xOTg1IDMuMDUzNjkgMTMuODMyMSAwIDkuNzUyNDcgMFYyWiIgZmlsbD0iIzVDNjQ3NSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNzUyNDcgMTJDNy44ODg2MyAxMiA2LjMyMjUzIDEwLjcyNTIgNS44Nzg0OSA5SDAuNzUyNDcyVjdINS44Nzg0OUM2LjMyMjUzIDUuMjc0NzcgNy44ODg2MyA0IDkuNzUyNDcgNEMxMS45NjE2IDQgMTMuNzUyNSA1Ljc5MDg2IDEzLjc1MjUgOEMxMy43NTI1IDEwLjIwOTEgMTEuOTYxNiAxMiA5Ljc1MjQ3IDEyWk05Ljc1MjQ3IDEwQzEwLjg1NyAxMCAxMS43NTI1IDkuMTA0NTcgMTEuNzUyNSA4QzExLjc1MjUgNi44OTU0MyAxMC44NTcgNiA5Ljc1MjQ3IDZDOC42NDc5IDYgNy43NTI0NyA2Ljg5NTQzIDcuNzUyNDcgOEM3Ljc1MjQ3IDkuMTA0NTcgOC42NDc5IDEwIDkuNzUyNDcgMTBaIiBmaWxsPSIjNUM2NDc1Ii8+Cjwvc3ZnPgo=";
export { SvgConnectionIcon as ReactComponent };